// base=/etc/designs/portal/clientlibs/sdx_expand/js/modules

import 'etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXAccordion.js';
import 'etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.js';
import 'etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.Image.js';

// Modern modules (using imports/exports)
import SDXAutoInit from 'lib/sdx/Tc.Module.SDXAutoInit';

const modernTcModules = {
	SDXAutoInit,
	SdxAutoInit: SDXAutoInit,
};
// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.portal.sdx.expand.ts